import { render, staticRenderFns } from "./CrispChatButton.vue?vue&type=template&id=30e5920a&scoped=true"
import script from "./CrispChatButton.vue?vue&type=script&lang=js"
export * from "./CrispChatButton.vue?vue&type=script&lang=js"
import style0 from "./CrispChatButton.vue?vue&type=style&index=0&id=30e5920a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e5920a",
  null
  
)

export default component.exports